import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaskJobItem } from '@store/actions/taskJobActions';

interface TaskJobState {
    taskJobList: { results: TaskJobItem[]; count: number };
    loading: boolean;
    actionLoading: boolean;
}

const initialState: TaskJobState = {
    taskJobList: { results: [], count: 0 },
    loading: false,
    actionLoading: false,
};

const taskJobSlice = createSlice({
    name: 'taskJob',
    initialState,
    reducers: {
        setTaskJobList: (state, action: PayloadAction<{ results: TaskJobItem[]; count: number }>) => {
            state.taskJobList = action.payload;
        },
        clearTaskJobList: (state) => {
            state.taskJobList = { results: [], count: 0 };
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setActionLoading: (state, action: PayloadAction<boolean>) => {
            state.actionLoading = action.payload;
        },
    },
});

export const { setTaskJobList, clearTaskJobList, setLoading, setActionLoading } = taskJobSlice.actions;
export default taskJobSlice.reducer;
